import {
  COMMON_CONSTANTS,
  getTranslatedText,
  PSA_CONSTANTS
} from '@nile/components';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/mangifera/src/Pebbles/select';
import { Badge, Dropdown } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { GET_FIELD } from '@nile/banyan/src/Graphql/Mutations/ticket';
import { useQuery } from '@apollo/client';
import { AccountClient } from '@nile/graphql';
import { SVGIcon } from '@superops/super-icons';

const ICON_MAP = {
  SERVICE_REQUEST: { icon: 'Cart', color: 'info' },
  INCIDENT: { icon: 'InlineError', color: 'critical' }
};

function TicketTypeContainer(props) {
  const { onChange, currentValue, intl, showIcon = true } = props;

  const convertToDropDown = (val) => {
    if (val) {
      return {
        label: val.value || val, // Removing lokalise as now we allow edit for ticket type
        name: val.value || val,
        value: val.value || val,
        id: val.id
      };
    }
  };
  const [value, setValue] = useState(
    currentValue ? convertToDropDown(currentValue) : null
  );
  const [ticketTypes, setTicketTypes] = useState([]);
  const { loading } = useQuery(GET_FIELD, {
    client: AccountClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NETWORK_ONLY,
    variables: {
      input: {
        module: 'TICKET',
        columnName: 'ticketType'
      }
    },
    onCompleted: (res) => {
      const options = res?.getField?.options || res?.getField?.fieldOptions;
      if (options) {
        const dropdownConvertedOptions = options.map((a) => {
          const convertedValues = convertToDropDown(a);
          return {
            ...a,
            ...convertedValues
          };
        });
        setTicketTypes(dropdownConvertedOptions);
        if (!currentValue && dropdownConvertedOptions) {
          const incidentType = dropdownConvertedOptions.find(
            (type) => type?.details?.property === 'INCIDENT'
          );
          if (incidentType?.value) {
            setValue(incidentType || null);
            onChange('ticketType', incidentType.value);
          }
        }
      }
    }
  });

  const getIconData = () => {
    const selectedValueData = ticketTypes
      ? ticketTypes.find((type) => type?.id === value?.id)
      : null;
    const property = selectedValueData?.details?.property;
    const name = ICON_MAP?.[property]?.icon || 'Cube';
    const status = ICON_MAP?.[property]?.color || null;

    return { name, status };
  };

  const { name, status } = getIconData();

  return (
    <div className="fx g10 actr w100">
      {showIcon && (
        <Badge radial status={status} size="small">
          <div className="opacity6 flex">
            <SVGIcon name={name} />
          </div>
        </Badge>
      )}
      <div className={props?.fullWidth ? 'w100' : 'w150p'}>
        <Dropdown
          value={value}
          onChange={(val) => {
            setValue(val);
            onChange('ticketType', val.value || null);
          }}
          isLoading={loading}
          placeholder={getTranslatedText(intl, 'app.chooseValue.pl')}
          name="forms"
          options={ticketTypes}
          classNamePrefix="value_selector"
          noBorder
          formatGroupLabel={formatGroupLabel}
          menuPlacement="auto"
          closeMenuOnScroll={(e) => {
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999
            })
          }}
        />
      </div>
    </div>
  );
}
export default injectIntl(TicketTypeContainer);
